import React from "react";
import ModalInfo from "../../ModalInfo";

class Page2 extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    visible: true,
    questionAnswer: null,
    showAnswer1: false,
    showAnswer2: false,
    showAnswer3: false,
    age: null,

    modalShow: true,
    instructions: (
      <div>
        <p>
          We will begin by investigating your ideas which will help you to focus
          your thinking. Before we jump into this, you may find it helpful to
          understand the UK graduate job market. We will do this by completing a
          short quiz.
        </p>
      </div>
    ),
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 2) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }

  /*onChange(e) {
    this.setState({
      showAnswer1: true,
    });
  }*/

  saveAgeChange = (event) => {
    this.setState({
      age: event.target.value,
      questionAnswer: event.target.value,
    });
    this.props.updatePdf(event.target.value);
  };

  render() {
    let defaultButton = "btn btn-outline-primary btn-lg btn-block";
    let rightButton = "btn btn-success btn-lg btn-block disabled";
    let wrongButton = "btn btn-danger btn-lg btn-block disabled";

    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">Quiz</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() => this.setState({ modalShow: true })}
                  ></i>
                </div>
              </ul>
            </nav>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex ">
                        <div className="p-2" id="moduleContentText">
                          Does your course of study determine your future career
                          path?
                        </div>
                      </div>
                      <br />
                      <button
                        type="button"
                        className={
                          this.state.showAnswer1 ? wrongButton : defaultButton
                        }
                        onClick={() =>
                          this.setState({
                            showAnswer1: true,
                          })
                        }
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className={
                          this.state.showAnswer1 ? rightButton : defaultButton
                        }
                        onClick={() =>
                          this.setState({
                            showAnswer1: true,
                          })
                        }
                      >
                        No
                      </button>
                    </li>

                    <li className="list-group-item form-card-2">
                      <div className="d-flex flex-column bd-highlight mb-3 ">
                        {this.state.showAnswer1 ? (
                          <div className="p-2" id="moduleContentText">
                            In comparison to many countries, employers in the UK
                            are far less interested in your degree subject.
                            Graduate recruiters in the UK are ‘degree neutral’
                            this means they are looking for candidates who have
                            the right combination of skills, sector knowledge
                            and genuine passion for their business.
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex ">
                        <div className="p-2" id="moduleContentText">
                          In your working life, how many times will you change
                          your career?
                        </div>
                      </div>
                      <br />
                      <button
                        type="button"
                        className={
                          this.state.showAnswer2 ? wrongButton : defaultButton
                        }
                        onClick={() =>
                          this.setState({
                            showAnswer2: true,
                          })
                        }
                      >
                        3
                      </button>
                      <button
                        type="button"
                        className={
                          this.state.showAnswer2 ? rightButton : defaultButton
                        }
                        onClick={() =>
                          this.setState({
                            showAnswer2: true,
                          })
                        }
                      >
                        7
                      </button>

                      <button
                        type="button"
                        className={
                          this.state.showAnswer2 ? wrongButton : defaultButton
                        }
                        onClick={() =>
                          this.setState({
                            showAnswer2: true,
                          })
                        }
                      >
                        11
                      </button>
                    </li>

                    <li className="list-group-item form-card-2">
                      <div className="d-flex flex-column bd-highlight mb-3 ">
                        {this.state.showAnswer2 ? (
                          <div className="p-2" id="moduleContentText">
                            The average person will change careers 5-7 times
                            during their working life. Therefore, don’t focus on
                            finding that one perfect job. At this stage, make
                            the most of all the opportunities available to you
                            and focus on your personal development, so that you
                            are able to grasp opportunities that come along your
                            way.
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex ">
                        <div className="p-2" id="moduleContentText">
                          It can be useful to put into context how long a
                          working career can be. One way to do this is to
                          subtract your current age from 70 to give you an
                          approximation of the number of potential working years
                          you have ahead of you.
                        </div>
                      </div>
                      <br />
                      <input
                        type="number"
                        className="form-control form-control-lg"
                        id="ageInput"
                        placeholder="Your age.."
                        max="69"
                        min="16"
                        value={this.state.questionAnswer}
                        onChange={this.saveAgeChange}
                      />
                      <br />
                      <button
                        type="button"
                        className={defaultButton}
                        onClick={() =>
                          this.setState({
                            showAnswer3: true,
                          })
                        }
                      >
                        OK
                      </button>
                    </li>

                    <li className="list-group-item form-card-2">
                      <div className="d-flex flex-column bd-highlight mb-3 ">
                        {this.state.showAnswer3 ? (
                          <div className="p-2" id="moduleContentText">
                            You have {70 - this.state.age} potential working
                            years ahead of you.
                            <br />
                            <br />
                            Reflect on your experiences to-date and how you’ve
                            changed in that time. Apply the same thinking to
                            your remaining future career will put into
                            perspective how long and varied your working life
                            might be.
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title="INSTRUCTIONS"
              content={this.state.instructions}
            />
            <br />
            <br />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page2;
